import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Challenge from "@/components/Challenge";
import Programs from "@/components/Programs";
import SignatureDay from "@/components/SignatureDay";
import OpportunityLab from "@/components/OpportunityLab";
import About from "@/components/About";
import Credibility from "@/components/Credibility";
import Stages from "@/components/Stages";
import Videos from "@/components/Videos";
import Results from "@/components/Results";
import SpeakingTopics from "@/components/SpeakingTopics";
import Engagements from "@/components/Engagements";
import Pricing from "@/components/Pricing";
import WhyPhillip from "@/components/WhyPhillip";
import Connections from "@/components/Connections";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Challenge />
        <Programs />
        <SignatureDay />
        <OpportunityLab />
        <About />
        <Credibility />
        <Stages />
        <Videos />
        <Results />
        <SpeakingTopics />
        <Engagements />
        <Pricing />
        <WhyPhillip />
        <Connections />
        <Contact />
      </main>
      <Footer />
      <Toaster richColors position="bottom-right" />
    </div>
  );
}
